import React from 'react';
import { ButtonGroup as BSButtonGroup } from 'react-bootstrap';
import AnimatedButton from '../../custom/AnimatedButton';

interface ButtonAction {
  url: string;
  method: string;
}

interface Button {
  icon: {
    value: string;
  };
  action: ButtonAction;
}

interface ButtonGroupProps {
  block: {
    buttons: Button[];
  };
  cardContext?: any;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ block, cardContext }) => {
  const handleButtonClick = async (action: ButtonAction): Promise<void> => {
    try {
      const response = await fetch(action.url, {
        method: action.method,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to process button action');
      }
    } catch (error) {
      console.error('Error processing button action:', error);
    }
  };

  return (
    <BSButtonGroup>
      {block.buttons.map((button, index) => (
        <AnimatedButton
          key={index}
          variant="outline"
          onClick={() => handleButtonClick(button.action)}
          className="d-flex align-items-center gap-2"
        >
          <img src={button.icon.value} alt="" className="icon-button-img" />
        </AnimatedButton>
      ))}
    </BSButtonGroup>
  );
};

export default ButtonGroup;
